import { isLaminate } from './is-laminate';
import { drawerHeaderHeight } from '../const';

export const getPageDrawerHeight = ({ type, isMobile }: { type: string; isMobile: boolean }) => {
  const isLaminateType = isLaminate(type);
  if (isLaminateType) {
    return isMobile ? drawerHeaderHeight.LAMINATE_MOBILE : drawerHeaderHeight.LAMINATE;
  }

  return drawerHeaderHeight.INTERIOR_DOORS;
};
